import React, { useEffect, useState } from "react";
import { Box, HStack, Badge, Text, Spinner, Select } from "@chakra-ui/react";
import { MapContainer, TileLayer, Marker, Popup, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import client from "../../../helpers/Client";
import urlToId from "../../../helpers/UrlToId";
import Link from "../../../components/Link";
import { TicketState } from "../../../components/States";

// Leaflet marker icon fix for bundlers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function TicketsMap() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [baseCenter, setBaseCenter] = useState([39.9208, 32.8541]);
  const [filterState, setFilterState] = useState("all");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const { data } = await client.get("/tickets/", { params: { page_size: 1000, ordering: "-created" } });
        const rows = (data.results || data || []).filter(
          (t) => t && t.latitude && t.longitude
        );
        setTickets(rows);
        if (rows.length) {
          setBaseCenter([Number(rows[0].latitude), Number(rows[0].longitude)]);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const visibleTickets = tickets.filter((t) => {
    if (filterState === "all") return true;
    return String(t.state) === String(filterState);
  });

  return (
    <Box p={4}>
      <HStack justify="space-between" mb={3}>
        <Text fontSize="lg" fontWeight="bold">Harita</Text>
        <HStack spacing={3}>
          <Badge colorScheme="blue">Toplam: {visibleTickets.length}</Badge>
          <Select size="sm" value={filterState} onChange={(e) => setFilterState(e.target.value)} w="180px">
            <option value="all">Tümü</option>
            <option value="in_progress">İşlemde</option>
            <option value="pending">Beklemede</option>
            <option value="completed">Tamamlandı</option>
          </Select>
        </HStack>
      </HStack>
      <Box border="1px solid #e2e8f0" borderRadius="xl" overflow="hidden" height="70vh">
        {loading ? (
          <HStack h="100%" justify="center"><Spinner /></HStack>
        ) : (
          <MapContainer center={baseCenter} zoom={6} style={{ height: "100%", width: "100%" }}>
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name="Uydu (Esri)">
                <TileLayer
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                  attribution="Tiles © Esri"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenStreetMap">
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="&copy; OpenStreetMap contributors"
                />
              </LayersControl.BaseLayer>
            </LayersControl>
            {visibleTickets.map((t) => {
              const lat = Number(t.latitude);
              const lng = Number(t.longitude);
              if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
              const id = urlToId(t.url);
              return (
                <Marker key={t.url || `${lat},${lng}`} position={[lat, lng]}>
                  <Popup>
                    <Box>
                      <HStack justify="space-between" mb={1}>
                        <Text fontWeight="bold">#{id}</Text>
                        <TicketState state={t.state} />
                      </HStack>
                      <Text fontSize="sm" mb={2}>{t.address || "-"}</Text>
                      <Link to={`/is-emri/${id}/`}>Detaya Git</Link>
                    </Box>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        )}
      </Box>
    </Box>
  );
}
